/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pregnancy-vaccine.reducer';

export const PregnancyVaccineDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pregnancyVaccineEntity = useAppSelector(state => state.pregnancyVaccine.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pregnancyVaccineDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.detail.title">PregnancyVaccine</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.id">Id</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.active">Active</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pregnancyVaccineEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.vaccine">Vaccine</Translate>
          </dt>
          <dd>{pregnancyVaccineEntity.vaccine ? pregnancyVaccineEntity.vaccine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{pregnancyVaccineEntity.pregnancy ? pregnancyVaccineEntity.pregnancy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyVaccine.trimester">Trimester</Translate>
          </dt>
          <dd>{pregnancyVaccineEntity.trimester ? pregnancyVaccineEntity.trimester.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pregnancy-vaccine" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pregnancy-vaccine/${pregnancyVaccineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PregnancyVaccineDetail;
